import {
    CONFIRM_MODAL,
    CONFIRM_MODAL_FAIL,
    CONFIRM_MODAL_RESET,
    CONFIRM_MODAL_SET_PARAMS,
    CONFIRM_MODAL_SUCCESS
} from './constants';

// 删除
export const ConfirmModalReducer = (state = {}, action) => {
    let ret = {
        ...state,
        idKey: Math.random()
    }
    const data = action.payload;
    switch (action.type) {
        case CONFIRM_MODAL_RESET:
            ret.loading = false;
            ret.saveSuccess = null;
            ret.error = null;
            ret.params = null;
            break;
        case CONFIRM_MODAL_SET_PARAMS:
            ret.params = data.params;
            break;
        case CONFIRM_MODAL:
            ret.loading = true;
            ret.saveSuccess = null;
            ret.error = null;
            break;
        case CONFIRM_MODAL_SUCCESS:
            ret.loading = false;
            ret.saveSuccess = true;
            break;
        case CONFIRM_MODAL_FAIL:
            ret.loading = false;
            ret.saveSuccess = false;
            ret.error = data;
            break;
        default:
            return {...state}
    }
    return ret;
}